/*
 * Sonatype Nexus (TM) Open Source Version
 * Copyright (c) 2008-present Sonatype, Inc.
 * All rights reserved. Includes the third-party code listed at http://links.sonatype.com/products/nexus/oss/attributions.
 *
 * This program and the accompanying materials are made available under the terms of the Eclipse Public License Version 1.0,
 * which accompanies this distribution and is available at http://www.eclipse.org/legal/epl-v10.html.

/** A small in-memory cache whose entries expire after a fixed time; the oldest entry goes first when it is full. */

const MAX_HINTS = 200;

const hints = new Map<string, string>();

/**
 * Remembers the name a list row showed for a component, so the detail page can put it in the breadcrumb while the
 * component is still loading. A component's name does not change, so the hint never expires; it is only a hint, and
 * the loaded name wins.
 */
export function rememberComponentName(key: string, name: string): void {
  if (!name) {
    return;
  }
  hints.delete(key);
  if (hints.size >= MAX_HINTS) {
    const oldest = hints.keys().next().value;
    if (oldest !== undefined) {
      hints.delete(oldest);
    }
  }
  hints.set(key, name);
}

export function componentNameHint(key: string): string | undefined {
  return hints.get(key);
}
